export default __webpack_public_path__ + "static/media/Suggetedproduct.b177c702.svg";